// extracted by mini-css-extract-plugin
module.exports = {"comp-subscribe-banner":"subscribe-banner_comp-subscribe-banner__se3F0","subscribe-banner":"subscribe-banner_subscribe-banner__F_VO1"};